import ActiveRolesDashFilter from "./components/ActiveRolesDashFilter";
import CaseStatusDashFilter from "./components/CaseStatusDashFilter";
import DashboardCard from "./components/DashboardCard";
import MedicalStatusDashFilter from "./components/MedicalStatusDashFilter";
import OtherPagesDashFilter from "./components/OtherPagesDashFilter";

const CaseListHeader = ({ userStats }) => {
  return (
    <div id="Dashboard" data-testid="Dashboard">
      <div id="Dashboard-Content">
        <div id="Dashboard-Filters">
          <div
            className="mb-4 flex w-full"
            style={{
              gap: "24px",
            }}
          >
            <DashboardCard title={"Active Roles"} icon="his-person-check">
              <ActiveRolesDashFilter
                roleCounts={userStats.roleCounts}
                totalCases={userStats.totalCases}
                withRoleAssignmentCount={userStats.withRoleAssignmentCount}
                withoutRoleAssignmentCount={userStats.withoutRoleAssignmentCount}
              />
            </DashboardCard>
            <DashboardCard title={"Case Status"} icon="his-recent-documents">
              <CaseStatusDashFilter caseStatusCounts={userStats.caseStatusCounts} />
            </DashboardCard>
            <DashboardCard title={"Medical Status"} icon="his-handshake-heart">
              <MedicalStatusDashFilter medicalStatusData={userStats.medicalStatusCounts} />
            </DashboardCard>
            <DashboardCard title={"Other Pages"} icon="his-layers">
              <OtherPagesDashFilter />
            </DashboardCard>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CaseListHeader;
